/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AuthRequest {
    getFixupPrototypeFunction() { return AuthRequest.fixupPrototype; }

    static newInstance(model: Partial<AuthRequest>): AuthRequest {
        let obj = Object.assign(new AuthRequest(), model);
        AuthRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AuthRequest>): AuthRequest {
        if (!model) return null;
        return AuthRequest.newInstance(<AuthRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AuthRequest) {
        if (!obj) return;

        models.AuthRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AuthRequest): boolean {
        Object.setPrototypeOf(obj, AuthRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * API Access Key. This can be retrieved from the <b>My Profile</b> page. Also this will be sent over email when the keys are generated.Please enter username and password pair or access_key and secret_key pair
     */
    access_key: string;

    /**
     * API Secret Key. This will be available in the email sent when the keys are generated. If you have lost the secret key, it cannot be retrieved. Request your admin to generate a new set of keys, if lost.Please enter username and password pair or access_key and secret_key pair
     */
    secret_key: string;

    /**
     * User name which will be used to login to corestack.Please enter username and password pair or access_key and secret_key pair
     */
    username: string;

    /**
     * Password which will be used to login to corestack.Please enter username and password pair or access_key and secret_key pair
     */
    password: string;

}
